import { Dayjs } from 'dayjs';

export function formatReportPreviewDateRange(
  startDate: Dayjs,
  endDate: Dayjs,
): string {
  if (startDate.isSame(endDate, 'year')) {
    return `${startDate.format('D.M.')} - ${endDate.format('D.M.YYYY')}`;
  }

  return `${startDate.format('D.M.YYYY')} - ${endDate.format('D.M.YYYY')}`;
}
